function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import './style';

var Icon = function Icon(_ref) {
  var className = _ref.className,
      style = _ref.style,
      svg = _ref.svg,
      spinning = _ref.spinning,
      _ref$clockwise = _ref.clockwise,
      clockwise = _ref$clockwise === void 0 ? true : _ref$clockwise,
      rest = _objectWithoutProperties(_ref, ["className", "style", "svg", "spinning", "clockwise"]);

  return _jsx("span", Object.assign({
    style: style,
    className: classnames(className, 'igloo-icon', {
      'igloo-icon-spin-clock': spinning && clockwise,
      'igloo-icon-spin-counter-clock': spinning && !clockwise
    })
  }, rest, {
    children: svg
  }), void 0);
};

var generateIcon = function generateIcon(svg) {
  return function (props) {
    return _jsx(Icon, Object.assign({
      svg: svg
    }, props), void 0);
  };
};

export default generateIcon;